<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav" ref="viewBox" id="viewBox">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img v-if="ban == 1" src="@/assets/img/logo/black.png" />
        <img v-if="ban == 2" src="@/assets/img/logo/white.png" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          ref="bgc"
          v-for="(item, index) in navList"
          :key="index"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path">
            <span
              :class="[ban == 1 ? 'spanboxTwo' : 'spanbox']"
              ref="spanbox"
              >{{ item.name }}</span
            >
            <i
              :class="index === navIndex ? 'underlineTwo' : 'underline'"
              id="under"
            ></i>
          </router-link>
          <div v-if="item.children.length > 0" class="dlCard">
            <div class="title">{{ item.name }}</div>
            <div class="dlCenter">
              <div v-for="(i, n) in item.children" :key="n" class="dtCar">
                <router-link :to="i.path"
                  >{{ i.name }}
                  <i class="underline"></i>
                </router-link>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 右侧固定窗口 -->
    <div class="flort">
      <div class="childs childsOne">
        <div
          class="el-icon-phone-outline icon"
          style="font-size: 26px;height: 50%;"
        ></div>
        <div style="font-size: 12px;">电话咨询</div>
        <div class="childs-hover childs-hoverOne">
          <div class="childs-back">
            400-010-1918
          </div>
          <div class="el-icon-caret-right"></div>
        </div>
      </div>
      <div class="childs childsTwo">
        <div
          class="el-icon-chat-line-square icon"
          style="font-size: 26px;height: 50%;"
        ></div>
        <div style="font-size: 12px;">投资加盟</div>
        <div class="childs-hoverTwo">
          <div class="childs-back">
            <img src="@/assets/images/qrcode_investment.jpg" alt="" />
          </div>
          <div class="el-icon-caret-right"></div>
        </div>
      </div>
      <div class="childs childsThree">
        <div
          class="el-icon-mobile-phone icon"
          style="font-size: 26px;height: 50%;"
        ></div>
        <div style="font-size: 12px;">公众号</div>
        <div class="childs-hoverThree">
          <div class="childs-back">
            <img src="@/assets/images/qrcode_gh_0419949d5613_1.jpg" alt="" />
          </div>
          <div class="el-icon-caret-right"></div>
        </div>
      </div>
      <div class="childs childsFour">
        <div
          class="el-icon-service icon"
          style="font-size: 26px;height: 50%;"
        ></div>
        <div style="font-size: 12px;">售后服务</div>
        <!--        <div class="childs-hoverFour">
          <div class="childs-back">
            phoneNumber
          </div>
          <div class="el-icon-caret-right"></div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  created() {
    // this.$metaInfo = {
    //   meta: [
    //     {
    //       name: "keywords",
    //       content:
    //         "联合新能源，联合换电，联合新能源换电，联合新能源换电柜，联合新能源换电车，前端换电"
    //     },
    //     {
    //       name: "description",
    //       content:
    //         "行业内首先提出车电分离，电池标准化并共享的续能理念，创新研发1155自主可控换电体系，突破行业发展瓶颈，让电动汽车无限续航。"
    //     }
    //   ]
    // };
  },
  data() {
    return {
      navIndex: 0,
      ban: 2,
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "整体方案",
          path: "/software",
          children: []
        },
        {
          name: "产品中心",
          path: "/service",
          children: []
        },
        {
          name: "投资加盟",
          path: "/jobchance",
          children: []
        },
        {
          name: "新闻资讯",
          path: "/newsList",
          children: []
        },
        {
          name: "关于我们",
          path: "/newsinformation",
          children: []
          // children: [
          //   {
          //     name: "发展历程",
          //     path: "/companyintroduction"
          //   },
          //   {
          //     name: "换电网络",
          //     path: "/aboutUs"
          //   },
          // ]
        },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ]
    };
  },
  watch: {
    index: {
      immediate: true,
      handler(val) {
        // 监听当前页面
        this.navIndex = val;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // 判断是否是首页，首页根据幻灯片索引触发
    if (this.$route.name == "home") {
      this.$bus.$on("change", e => {
        this.changeStyle(e == 1 ? true : false);
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 滚动条监听
    handleScroll() {
      this.changeStyle(window.scrollY > 0);
    },
    // 判断导航栏状态
    changeStyle(value) {
      if (value) {
        setTimeout(() => {
          if (this.$refs.viewBox) {
            this.$refs.viewBox.style.background = "#fff";
          }
        }, 10);
        this.ban = 1;
      } else {
        setTimeout(() => {
          if (this.$refs.viewBox) {
            this.$refs.viewBox.style.background = "transparent";
          }
        }, 10);
        this.ban = 2;
      }
    },
    // 点击导航栏的操作
    navClick(index, name) {
      this.navIndex = index;
    }
  }
};
</script>

<style scoped lang="scss">
// 左侧悬浮窗
.flort {
  position: fixed;
  right: 50px;
  bottom: 220px;
  width: 56px;
  height: 330px;
  border-radius: 10px;
  background-color: white;
  //   color: #fff;
  z-index: 9999;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 3px 1px #ccc;
  .childs {
    width: 100%;
    height: 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // 电话咨询
    .childs-hover {
      position: absolute;
      top: 0px;
      left: -187px;
      width: 190px;
      display: none;
      .el-icon-caret-right {
        font-size: 28px;
        color: white;
        margin-left: -10px;
        display: flex;
        align-items: center;
      }
      .childs-back {
        text-align: center;
        width: 160px;
        border-radius: 20px;
        background: white;
        padding: 20px;
        font-size: 18px;
        position: relative;
      }
    }
    // investment
    .childs-hoverTwo {
      position: absolute;
      top: 80px;
      left: -200px;
      width: 200px;
      height: 250px;
      display: none;
      .el-icon-caret-right {
        font-size: 28px;
        color: white;
        margin-left: -10px;
        display: flex;
        // align-items: center;
        margin-top: 20px;
      }
      .childs-back {
        text-align: center;
        width: 100%;
        height: 200px;
        border-radius: 20px;
        background: white;
        padding: 20px;
        font-size: 18px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    // app
    .childs-hoverThree {
      position: absolute;
      top: 162px;
      left: -200px;
      width: 200px;
      height: 250px;
      display: none;
      .el-icon-caret-right {
        font-size: 28px;
        color: white;
        margin-left: -10px;
        display: flex;
        // align-items: center;
        margin-top: 20px;
      }
      .childs-back {
        text-align: center;
        width: 100%;
        height: 200px;
        border-radius: 20px;
        background: white;
        padding: 20px;
        font-size: 18px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    // 联系售后服务
    .childs-hoverFour {
      position: absolute;
      bottom: 0px;
      left: -187px;
      width: 190px;
      display: none;
      .el-icon-caret-right {
        font-size: 28px;
        color: white;
        margin-left: -10px;
        display: flex;
        align-items: center;
      }
      .childs-back {
        text-align: center;
        width: 160px;
        border-radius: 20px;
        background: white;
        padding: 20px;
        font-size: 18px;
        position: relative;
      }
    }
  }
}
.childs:hover {
  color: #01afab;
  cursor: pointer;
}
// 电话咨询显示
.childsOne:hover .childs-hoverOne {
  display: flex;
  color: #000;
}
// 招商加盟
.childsTwo:hover .childs-hoverTwo {
  display: flex;
  color: #000;
}
// app显示
.childsThree:hover .childs-hoverThree {
  display: flex;
  color: #000;
}
// 售后服务线
.childsFour:hover .childs-hoverFour {
  color: #000;
  display: flex;
}
a:link {
  color: blue;
  text-decoration: none;
} //未访问：蓝色、无下划线
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
  position: relative;
  /* 导航栏 */
  .header-nav {
    height: 70px;
    width: 100%;
    position: fixed;
    z-index: 9999;
    //   background: #fff;
    //   color:#fff;
    display: flex;
    justify-content: space-around;
    /* 导航栏logo */
    .header-nav-logo {
      width: 100px;
      height: 100%;
      float: left;
      position: relative;
      /* 导航栏logo图片 */
      img {
        width: 150px;
        height: 50px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
    /* 导航栏 导航容器 */
    .header-nav-wrapper {
      line-height: 70px;
      float: right;
      margin: 0;
      max-width: 800px;
      position: relative;
      /* 导航栏 每个导航 */
      li {
        float: left;
        margin: 0 15px;
        /* 导航栏 每个导航下面的 a 链接 */
        a {
          font-size: 15px;
          font-weight: bold;
          padding: 15px 0;
          position: relative;
          /* 导航栏 每个导航下面的 a 链接的下划线 */
          .underline {
            display: block;
            position: absolute;
            bottom: -2px;
            left: 50%;
            width: 0;
            height: 2px;
            opacity: 0;
            transition: all 0.6s ease;
            background-color: #01afab;
          }
          .underlineTwo {
            display: block;
            position: absolute;
            bottom: -2px;
            left: 0%;
            width: 100%;
            height: 2px;
            opacity: 1;
            transition: all 0.6s ease;
            background-color: #01afab;
          }
        }
        /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
        a:hover .underline {
          opacity: 1;
          width: 100%;
          left: 0;
        }
      }
      /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
      // li.active > a {
      //   color: #01AFAB;
      //   text-decoration: none;
      //   border-bottom: 2px solid #01AFAB;
      // }
    }
  }
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
// #header .header-nav .header-nav-wrapper > li > a > span {
//   font-size: 12px;
//   transition: transform ease 0.5s;
// }
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
// #header .header-nav .header-nav-wrapper > li > a:hover {
//   color: #01AFAB;
//   text-decoration: none;
// }

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
// #header .header-nav .header-nav-wrapper > li > a:hover span {
//   transform: rotate(180deg);
// }
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > .dlCard {
  display: none;
  width: 100vw;
  max-height: 35vh;
  transition: all 0.6s ease;
  background: #fff;
  transition: all 0.3s;
  position: absolute;
  top: 4vw;
  left: -56.5vw;
  z-index: -1;
  padding: 0 5vw 0 35vw;
  box-sizing: border-box;
  overflow: hidden;
  .title {
    width: 100%;
    height: 1.45vh;
    font-size: 1.041667vw;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 2.083333vw;
    margin: 0 0 2vw 6px;
    text-align: left;
  }
  .dlCenter {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-content: flex-start;
    // justify-content: space-around;
    //width: 100%;
    max-height: 30vh;
    white-space: nowrap;
    padding: 0 20px 10px 0px;
    line-height: 50px;
    margin-bottom: 1vh;
    /* 导航栏 每个导航下面的二级导航容器的每个导航 */

    .dtCar {
      width: 15%;
      margin: 0 30px 0 10px;
      height: 60px;
      a {
        display: block;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        letter-spacing: 0em;
        color: #666666;
        // padding: 10px 0;
        position: relative;
        border-bottom: 1px solid #d8d8d8;
        width: 100%;
        .underline {
          display: block;
          position: absolute;
          bottom: -2px;
          left: 50%;
          width: 0;
          height: 2px;
          opacity: 0;
          transition: all 0.6s ease;
          background-color: #01afab;
        }
      }
    }
  }
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header
  .header-nav
  .header-nav-wrapper
  > li
  > .dlCard
  > .dlCenter
  > .dtCar
  > a:hover {
  text-decoration: none;
  border-bottom: none;
  color: #01afab;
}
#header
  .header-nav
  .header-nav-wrapper
  > li
  > .dlCard
  > .dlCenter
  > .dtCar
  > a:hover
  .underline {
  opacity: 1;
  width: 100%;
  left: 0;
  background-color: #01afab;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover .dlCard {
  display: block;
}
#header
  .header-nav
  .header-nav-wrapper
  > li
  > .dlCard
  > .dlCenter
  > .dtCar:hover {
  cursor: pointer;
  /* background: #ccc; */
  color: #01afab;
  /* border-bottom: 1px solid #01AFAB; */
}
.spanbox {
  color: #fff;
}
.spanboxTwo {
  color: #000000;
}
// .mouseHeader{
//     // color:#fff;
//     background-color: #fff;
// }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue